export type tableStatus = 'active' | 'inactive';

export const tableStatusObject = {
  inactive: {
    color: 'error',
    translate: 'Inativo',
  },
  active: {
    color: 'success',
    translate: 'Ativo',
  },
  seller: {
    color: 'info',
    translate: 'Vendedor',
  },
  client: {
    color: 'default',
    translate: 'Cliente',
  },
  in: {
    color: 'success',
    translate: 'Acréscimo',
  },
  out: {
    color: 'error',
    translate: 'Decréscimo',
  },
  exemption: {
    translate: 'Isenção',
  },
  humanError: {
    translate: 'Acerto - erro humano',
  },
  systemicError: {
    translate: 'Acerto - erro sistêmico',
  },
  sac: {
    translate: 'Acerto - SAC',
  },
  refund: {
    translate: 'Reembolso de bônus livre',
  },
  takerate: {
    translate: 'Takerate',
  },
  true: {
    color: 'info',
    translate: 'Viva',
  },
  sellers: {
    color: 'default',
  },
  yes: {
    color: 'success',
  },
  no: {
    color: 'error',
  },
  aproved: {
    color: 'success',
    translate: 'Aprovado',
  },
  awaiting: {
    color: 'warning',
    translate: 'Aguardando Aprovação',
  },
  rejected: {
    color: 'error',
    translate: 'Rejeitado',
  },
  awaiting_sync: {
    color: 'warning',
    translate: 'Aguardando Geração',
  },
  error: {
    color: 'error',
    translate: 'Erro na Geração',
  },
  'Viva Mais': {
    color: 'warning',
    translate: 'Viva Mais',
  },
  'Clube Viva': {
    color: 'secondary',
    translate: 'Clube Viva',
  },
  promo: {
    color: 'error',
    translate: 'Sorteio',
  },
  experience: {
    color: 'warning',
    translate: 'Experiência',
  },
  vb: {
    color: 'info',
    translate: 'Vale Bônus',
  },
  sent: {
    color: 'success',
    translate: 'Relatório Enviado',
  },
  pending: {
    color: 'warning',
    translate: 'Relatório Pendente',
  },
  generated: {
    color: 'info',
    translate: 'Relatório Gerado',
  },
  'ready-to-send': {
    color: 'info',
    translate: 'Pronto Para Envio',
  },
  silver: {
    color: 'default',
    translate: 'Prata',
  },
  gold: {
    color: 'warning',
    translate: 'Ouro',
  },
  diamond: {
    color: 'info',
    translate: 'Diamante',
  },
};

export function tableStatusColor(status: tableStatus) {
  return tableStatusObject[status]
    ? tableStatusObject[status]
    : {
        color: 'primary',
        translate: '-',
      };
}
